/**
 * SiteFooter — data attribution (CC0 Open Data Südtirol), the live collector
 * status indicator, and a build marker. The estimated-wait figures elsewhere are
 * deliberately rough; the source link keeps the data provenance one click away.
 */

import { BuildStamp } from "./BuildStamp";
import { CollectorStatus } from "./CollectorStatus";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__main">
        <p>
          Dati:{" "}
          <a
            href="https://dati.retecivica.bz.it/services/PS_Queue/json"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Data Südtirol — PS_Queue
          </a>
          , licenza CC0.
        </p>
        <p className="footer-note">
          I numeri indicano le persone attualmente in attesa, non i tempi garantiti.
        </p>
        <BuildStamp />
      </div>
      <CollectorStatus />
    </footer>
  );
}
